import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

import { Asset } from "@hermes/api-model-asset";
import { Product } from "@hermes/api-model-product";
import { Context } from "@hermes/app-core";
import { PRODUCT_PAGE_IMAGE_SIZE } from "@hermes/fragments/product-utils";
import { ProductPageFacade } from "@hermes/states/product-page";

@Component({
    selector: "h-product-double-image",
    templateUrl: "./product-double-image.component.html",
    styleUrls: ["./product-double-image.component.scss"],
})
export class ProductDoubleImageComponent implements OnChanges {
    /** Current page product */
    @Input()
    public product: Product;

    /**
     * Product title. use in translation key for image alt
     */
    public productTitle: string;

    public asset: Asset;

    public size = PRODUCT_PAGE_IMAGE_SIZE;

    constructor(
        private readonly context: Context,
        private productPageFacade: ProductPageFacade,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (
            changes.product &&
            changes.product.currentValue !== changes.product.previousValue
        ) {
            this.productTitle = this.product.title;

            if (this.product.assets && this.product.assets.length > 0) {
                this.asset = this.product.assets[0];
            }
        }
    }

    /**
     * handle zoom activation
     */
    public handleZoomModal(zoomStatus: boolean): void {
        this.productPageFacade.toggleZoom({
            zoomStatus,
            zoomAssets: this.product.assets,
            currentIndex: 0,
        });
    }

    public handleFocus(): void {
        if (this.context.isInBrowserMode()) {
            window.scrollTo(0, 0);
        }
    }
}
